import styled from "styled-components";

export const Container = styled.p`
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-bottom: 0px;
  }
`

export const SectionTitle = styled.p`
  color: #212D45;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 26.4px;
  @media (max-width: 768px) {
    font-size: 16px;
    font-weight: 600;
  }
`

export const SectionSubTitle = styled.p`
  color: #4E6783;
  font-size: 16px;
  font-style: normal;
  line-height: 22.4px;
  margin-top: 8px;
  margin-left: 2px;
  @media (max-width: 768px) {
    font-size: 14px;
    font-weight: 400;
    margin-top: 9px;
  }
`;

export const SectionDivider = styled.div`
  @media (max-width: 768px) {
    background-color: #D4E3E9;
    width: 100%;
    height: 2px;
    margin-top: 20px;
    margin-bottom: 29px;
  }
  @media (max-width: 700px) {
    margin-top: 16px;
    margin-bottom: 24px;
  }
`